import React, { memo } from 'react'
import { Card, Stack } from '@mui/material'

import CopyrightTextWrapper from 'wrappers/CopyrightTextWrapper'
import CustomerHelpDeskWrapper from 'wrappers/CustomerHelpDeskWrapper'
import TermsPoliciesWrapper from 'wrappers/TermsPoliciesWrapper'
import { UNSUBSCRIBE_URL } from '../../constants/externalUrls'
import Button from '../shared/button/Button'
import customConfig from 'customConfig'
import brandConfig from 'brandConfig'
import CardHeading from '../text/CardHeading'
import { openExternalUrl } from '../../libs/qb-brand-web-components'
import Text from '../text/Text'

const MoreInformation = ({ t, extraLink }) => {
  const { disableTermsCheckbox } = brandConfig.features
  const handleUnsubscribe = () => {
    openExternalUrl(UNSUBSCRIBE_URL)
  }
  return (
    <Card
      sx={{
        p: 3
        // textAlign: 'center'
      }}
    >
      <CardHeading
        title={t('user-account.more-information')}
        desc={<CustomerHelpDeskWrapper t={t} />}
      />
      <Stack spacing={2}>
        {!disableTermsCheckbox && (
          <Text
            variant='body2'
            color='text.secondary'
            label={
              <TermsPoliciesWrapper
                t={t}
                i18nKey='brand:common.view-the-terms-policy'
              />
            }
          />
        )}
        {extraLink}
        <Text
          variant='body2'
          color='text.secondary'
          label={t(customConfig.unsubscribeMessageLabel)}
        />
        <Stack alignItems='flex-start' sx={{ mt: 1 }}>
          <Button
            color='error'
            variant='outlined'
            label={t(customConfig.deleteAccountLabel)}
            onClick={handleUnsubscribe}
          />
        </Stack>
        <CopyrightTextWrapper />
      </Stack>
    </Card>
  )
}

export default memo(MoreInformation)
